import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function ImageUploader({ onUploaded, label = "Upload image", testid = "image-uploader" }) {
    const ref = useRef(null);
    const [busy, setBusy] = useState(false);

    const handleFile = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        if (!file.type.startsWith("image/")) {
            toast.error("Vetëm foto (jpg, png, webp). Only images allowed.");
            return;
        }
        if (file.size > 10 * 1024 * 1024) {
            toast.error("Foto është më e madhe se 10MB. Image too large (max 10MB).");
            return;
        }
        setBusy(true);
        try {
            const form = new FormData();
            form.append("file", file);
            const res = await api.post("/upload", form, {
                headers: { "Content-Type": "multipart/form-data" },
                timeout: 60000,
            });
            onUploaded?.(res.data.path);
            toast.success("Foto u ngarkua / Uploaded");
        } catch (err) {
            const msg = err?.response?.data?.detail || err?.message || "Upload failed";
            toast.error(`Ngarkimi dështoi: ${msg}`);
        } finally {
            setBusy(false);
            if (ref.current) ref.current.value = "";
        }
    };

    /**
     * Using a <label> wrapping the input is the most reliable cross-browser
     * (especially iOS Safari) way to trigger a file picker. We keep the
     * input visually hidden but accessible (sr-only) instead of using
     * the `hidden` attribute which iOS sometimes blocks.
     */
    return (
        <label
            data-testid={`${testid}-btn`}
            className={`inline-flex items-center gap-2 px-4 py-2 border border-[#0F3A59]/30 text-[#0F3A59] rounded-full text-sm hover:bg-[#0F3A59] hover:text-white transition cursor-pointer select-none ${
                busy ? "opacity-50 pointer-events-none" : ""
            }`}
        >
            {busy ? (
                <Loader2 size={16} className="animate-spin" />
            ) : (
                <Upload size={16} strokeWidth={1.5} />
            )}
            {busy ? "Po ngarkohet..." : label}
            <input
                ref={ref}
                type="file"
                accept="image/*"
                onChange={handleFile}
                disabled={busy}
                data-testid={`${testid}-input`}
                className="sr-only"
            />
        </label>
    );
}
